import { buildApiUrl } from '../../services/apiConfig';

class KnowledgeGraphService {
  async request(endpoint, options = {}) {
    const token = localStorage.getItem('auth_token') || 'dev-token';
    const response = await fetch(buildApiUrl('NOVA_INGESTION', endpoint), {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        ...options.headers,
      },
      ...options,
    });
    if (!response.ok) {
      throw new Error(`API error ${response.status}: ${await response.text()}`);
    }
    return response.json();
  }

  async getSources() {
    return this.request('/sources');
  }

  async exploreGraph(sourceIds) {
    const params = sourceIds && sourceIds.length > 0
      ? `?source_ids=${sourceIds.map(id => encodeURIComponent(id)).join(',')}`
      : '';
    return this.request(`/semantic-graph/explore${params}`);
  }

  async getGraphStats() {
    return this.request('/semantic-graph/stats');
  }

  async listGraphDomains() {
    return this.request('/semantic-graph/domains');
  }

  async clearGraph() {
    return this.request('/semantic-graph/clear', { method: 'DELETE' });
  }

  async rebuildGraph() {
    return this.request('/semantic-graph/rebuild', { method: 'POST' });
  }
}

export default new KnowledgeGraphService();
